module.exports = __webpack_public_path__ + "img/mlu370.89df9881.png";